import { useQuery } from '@tanstack/react-query';

import { listOrders, OrderListFilter } from './api';

export function useOrderList(filter: OrderListFilter) {
  return useQuery({
    queryKey: ['orders', filter],
    queryFn: () => listOrders(filter),
  });
}
